import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const UserSearch = lazy(() =>
  import("@scenes/UserProfile/UserSearch").then((module) => ({ default: module.UserSearch }))
);

export const searchUsersNRO: NavigationRoutingObject = {
  Component: UserSearch,
  componentFeatureFlippers: ["search_users_nro_component"],
  section: "audience",
  heading: (t: I18nT<"dashboard-navigation">) => t("search-users-sidebar-pill-menu-option", "Search Users"),
  pageNameForTracking: () => "Search Users",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("search-users-description-nav", "View user profiles to find information about specific users"),
  icon: "nav-system-search-users",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("user-search", "User Search")],
      description: t("previously-user-search", 'Previously "User Search"'),
    },
  ],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/users/user_search/:appGroupId",
};
